import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const BidsAnalyticsModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=QjFxferfAxg&ab_channel=apadua" />
);

export default BidsAnalyticsModal;
